import getFileById from '@picsart/cloud-storage/api/getFileById';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  uid: string;
};

const getFile = async ({ uid }: Params) => {
  const result = await withCloudStorageErrorHandling({
    operation: () =>
      getFileById({ headers: getCloudStorageHeaders(), fileId: uid }),
    errorMessage: ErrorMessages.driveFile,
  });

  return result?.response ?? null;
};

export default getFile;
